module.exports = __webpack_public_path__ + "img/course-2.ee17f6b7.png";